import React from 'react';
import ReactDOM from 'react-dom/client';

function Footer(){
    return <div className="footer"><h3>Copyright @ Priyadarshi {new Date().getFullYear()}</h3></div>;

}
export default Footer;